<section class="section-white" *ngIf="caseFeatureData">
  <div 
    [class.section-container]="whitePaperData?.title"
    [class.section-container-inside]="!whitePaperData"
  >
    <h2 class="section-heading mar-b-48">{{ caseFeatureData?.title }}</h2>
    <div class="product-blog-container">
      <ng-container>
        <div class="product-blog-row">
          <div
            class="product-blog padd-48"
            *ngFor="
              let card of caseFeatureData?.component1;
              let odd = odd;
              let i = index
            "
            [ngClass]="
              i === 0
                ? 'moonstone-100'
                : i === 1
                  ? 'pink-100'
                  : i === 2
                    ? 'yellow-200'
                    : 'grey-100'
            "
          >
            <div>
              <div class="product-blog-heading mar-b-16">
                {{ card?.fields?.title }}
              </div>
              <div
                class="product-blog-description"
                [innerHtml]="card?.fields?.description | toHtml"
              ></div>
            </div>
            <figure>
              <img
                loading="lazy"
                src="{{ card?.fields?.imageicon?.fields?.file?.url }}"
                class="wid-full"
                alt=""
              />
            </figure>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
